import angular from 'angular'
import isObject from 'lodash/isObject'
import dataURItoBlob from './data-uri-to-blob'

export default (data) => {
    const fd = new FormData();
    //  console.log('uploadTransform.fd', data);
    angular.forEach(data.request, function (value, key) {
        if (value !== null) {
            if (isObject(value)) fd.append(key, angular.toJson(value));
            else fd.append(key, value);
            //  console.log('uploadTransform.json', key, value);
        }
    });
    angular.forEach(data.files, function (value, key) {
        //   console.log('uploadTransform.file', key, value);
        fd.append(key, value);
    });
    angular.forEach(data.dataUrls, function (dataURI, key) {
        const blob = dataURItoBlob(dataURI)
        //  console.log('uploadTransform.dataURI', key, dataURI.length);
        //   console.log('uploadTransform.blob', key, blob);
        fd.append(key, blob);
    });
    //   console.log('uploadTransform.fd', fd);
    return fd;
}
